import React from 'react'
import Img from "gatsby-image"

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class CharlotteLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Charlotte, NC" />
        <LocationMicroNav />

        { /* Charlotte, Story 1 */ }
        <LocationContent 
          category="Promoting Ridership" 
          title="Honoring a fallen champion"
          story=' In late May we joined NASCAR, MotoGP and AMA Supercross riders for a bike ride in Charlotte, North Carolina to honor the memory of Nicky Hayden. Hayden was a MotoGP world champion who was killed by by a distracted driver while cycling in Italy. Led by seven-time NASCAR champion Jimmie Johnson, the group paid tribute to Hayden by riding 69 (his race number) miles.'
        />
        <Img
          title="Charlotte 1-1"
          alt="Nicky Hayden memorial ride"
          sizes= { this.props.data.charlotteOneOneImage.sizes }
        />

        { /* Charlotte, Story 2 */ }
        <LocationContent 
          category="Promoting Ridership" 
          title="Carolina on Our Mind"
          story="Cyclofest, Interbike’s East Coast event, is a cycling festival for both bicycle retailers and consumers—a mix of demo bike opportunities, product displays, cyclocross races, food and music. The four-day event took place at the U.S. National Whitewater Center in Charlotte, NC. Our booth was front and center and we met retailers and other bike fanatics. One highlight: a chance to ride with mountain bike legend Ned Overend."
        />
        <Img
          title="Charlotte 2-1"
          alt="Cyclofest expo picture"
          sizes= { this.props.data.charlotteTwoOneImage.sizes }
        />

        <LocationRelated 
          prevLocationName="Detroit, MI"
          prevLocationPath="detroit"
          prevLocationImgPath= { this.props.data.charlottePrevImage }
          nextLocationName="Montana"
          nextLocationPath="montana"
          nextLocationImgPath= { this.props.data.charlotteNextImage }
        /> 
      </div>
    )
  }
}

export default CharlotteLocation 

// GraphQL queries for each image, got to be a better way to do this but whatever for now
export const CharlotteImageQuery = graphql`
  query CharlotteImageQuery {
    charlotteOneOneImage: imageSharp(id: { regex: "/PFB_Charlotte_1-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    charlotteTwoOneImage: imageSharp(id: { regex: "/PFB_Charlotte_2-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    charlottePrevImage: imageSharp(id: { regex: "/PFB_DETROIT/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    charlotteNextImage: imageSharp(id: { regex: "/PFB_MONTANA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/charlotte.js